export const EPath = {
  // NotFoundPage
  notFoundPage: '/notfound',

  // LoginPage
  loginPage: '/login',

  // create workspace
  omoteuraDiagnosis: '/omoteura-diagnosis-result',
  omoteuraDiagnosi: '/implements/omoteura-diagnosis-result/:employeeId/:eventId',
  omoteuraDiagnosiConsultant: '/interviews/omoteura-diagnosis-result/:employeeId/:eventId',
  omoteuraEmployeeAnswer: '/implements/omoteura-employee-answer/:employeeId/:eventId',
  omoteuraUpdateResult: '/implements/omoteura-update-result/:employeeId/:eventId',
  analyzeOmoteraDiagnosisResult: '/analyzeOmoteraDiagnosisResult',
  createAnalyzeOmoteraDiagnosisResult: '/analyzeOmoteraDiagnosisResult/create',
  analyzeReportDetail: '/analyzeOmoteraDiagnosisResult/:reportId',
  comparisonAxis: '/comparison-axis',

  // ID Master Management
  Client_ID_Management: '/client-management',
  Manager_ID_Management: '/client-management/:clientId/manager-management',
  Facility_ID_Management: '/client-management/:clientId/facility-management',
  Group_Management: '/client-management/:clientId/group-management',
  Com_ID_Management: '/.com-management',
  Employ_ID_Management: '/client-management/:clientId/:clientName/employ-management',
  Employ_Troubleshooting_Logs:
    '/client-management/:clientId/:clientName/employ-management/troubleshooting-logs/:employeeId',
  Employ_Troubleshooting_Log_Details:
    '/client-management/:clientId/:clientName/employ-management/troubleshooting-logs/:employeeId/:logId',
  Interviewer_ID_Management: '/interviewer-management',
  CareerMemoRegister: '/career-memo-register',
  Data_download: '/data-download',
  // a
  a: '/a',

  // b
  b: '/b',
  // icon
  icon: '/icon',

  // dashboard
  dashboard: '/dashboard',

  // file management
  file_management: '/file-management',

  // implements
  implements: '/implements',
  implementDetail: '/implements/:implementId',
  implementGroupDetail: '/implements/group/:bulkCode',
  message: '/message',

  // additional interview
  additionalInterview: '/additional-interview',
  additionalInterviewDetail: '/additional-interview/:interviewId',
  additionalInterviewGroupDetail: '/additional-interview/group/:bulkCode',
  additionalOmoteuraDiagnosi:
    '/additional-interview/omoteura-diagnosis-result/:employeeId/:eventId/:employeeProgressId?',
  additionalOmoteuraEmployeeAnswer:
    '/additional-interview/omoteura-employee-answer/:employeeId/:eventId',
  additionalOmoteuraUpdateResult:
    '/additional-interview/omoteura-update-result/:employeeId/:eventId',

  // consultant
  interviews: '/interviews',
  interviewDetail: '/interviews/:interviewId',
  Interview_Management: '/interview-management',
  Interview_Management_id: '/interview-management/:consultantId',
  Interview_Manual: '/interview-manual',
  Account_setting: '/account-setting',

  // employeesWeb
  employeeLogin: '/employee-login',
  employeeIdentity: '/employee-identity',
  employeeInitialPass: '/employee-initialPass',
  employeeWebHome: '/employee-home',
  employeeWebHomeStart: '/employee-home-start',
  employeeWebHomeFullStart: '/employee-home-full-start',
  employeeWebHomeFullStartTest: '/employee-home-full-start-test',
  employeeWebHomeStartTest: '/employee-home-start-test',
  employeeWebHomeComplete: '/employee-home-complete',

  // survey
  surveyList: '/survey-list',
  surveyProgressByFacility: '/survey-list/:surveyId',
  surveyProgressByGroup: '/survey-list/group/:bulkCode',
  surveyResult: '/survey-list/survey-result/:surveyId/:employeeId',
};
